export default "__VITE_ASSET__Bb$0UCt3__"